import { CHECKOUT_ERROR_CODES } from '@zenbusiness/application-commons-ecommerce/useSubmitOrder';

const FATAL = {
  isRetryable: false,
  logWorthy: true
};

/**
 * Parses the given Error object for known fail states and returns the appropriate message key.
 * @param {Error} e
 * @returns {{ title: string, subtitle: string }}
 */
export default function parseError(e) {
  const { extensions: { errorCode } = {}, path: pathArray = [] } = e;
  const path = pathArray.join('.');

  if (
    (path === 'orderSubmissionStatus' || path === 'convertCartToOrder') &&
    CHECKOUT_ERROR_CODES[errorCode]
  ) {
    // this is a standard checkout workflow user error. Checkout handles this, so we can ignore it.
    return {
      title: 'shopping.toast.error.title.checkout',
      message: `shopping.checkout.error.${errorCode}`,
      isRetryable: true,
      logWorthy: false
    };
  }

  switch (path) {
    case 'addCartItem': // For errors that occur while mutating the cart contents
    case 'addCartItems':
    case 'deleteCartItem':
    case 'deleteCartItems':
      return {
        message: 'shopping.toast.error.message.addItem',
        isRetryable: true,
        logWorthy: true
      };
    case 'updateCart': // BusinessInfo form fails to submit, getting CART_GET_FAIL
      return {
        message: 'shopping.toast.error.message.default',
        isRetryable: true,
        logWorthy: true
      };

    // no default
  }

  // everything else (FATAL errors) are not retryable and sent to ErrorBoundary
  return FATAL;
}
